<template>
  <v-toolbar app light color="white" flat scrollOffScreen>
    <MenuList  class="menu-list__stylus"/>
    <v-spacer></v-spacer>
    <v-btn v-if="$route.params.lang" icon :to="{name: 'Home', params: {lang: $route.params.lang}}">
      <v-icon>home</v-icon>
    </v-btn>

    <AppAvatar />
  </v-toolbar>
</template>

<script>
export default {
  components: {
    MenuList: () => import('./MenuList'),
    AppAvatar: () => import('@/components/common/AppAvatar')
  }
}
</script>

<style scoped>
.menu-list__stylus {
  width: 1200px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/ToolBar.vue